/* eslint-disable import/no-default-export */
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import LogoutTrigger from './logout-trigger';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

interface StateProps {
  readonly isLoggingOut: boolean;
  readonly returnUrl?: string;
}

class LogoutTriggerContainer extends React.Component<StateProps> {
  render() {
    return this.props.isLoggingOut && <LogoutTrigger {...this.props} />;
  }
}

const mapStateToProps = (state: State): StateProps => {
  return {
    isLoggingOut: state.models.session.isLoggingOut,
    returnUrl: state.models.session.returnUrl,
  };
};

const Connected = connect(mapStateToProps)(LogoutTriggerContainer);

const WithReduxProvider: React.FunctionComponent = () => {
  return (
    <ReduxProvider>
      <Connected />
    </ReduxProvider>
  );
};

export default WithReduxProvider;
